import React from "react";
import {PrePaymentSubmitButton} from "../../../pre-payment-submit-button/PrePaymentSubmitButton";
import {PaymentIntentResult, Stripe, StripeElements} from "@stripe/stripe-js";
import {EventTypeHolder, EventUtil} from "../../../../../../../util/EventUtil";
import {SnackbarServiceSingleton} from "src/Context";
import {StripeErrorMapper} from "../../../../../../../stripe/util/StripeErrorMapper";

interface Props {
    submitButtonDisabled: boolean;
    stripe: Stripe | null;
    elements: StripeElements | null;
    clientSecret?: string;
    returnUrl: string;
    paymentElementComplete: boolean;
}

export class PrePaymentAchSubmitButton extends React.Component<Props> {

    private readonly snackbarService = SnackbarServiceSingleton;

    private sendPaymentRequest = (): Promise<void> => {
        if (!this.props.stripe || !this.props.elements || !this.props.clientSecret) {
            const message = 'Payment form is not ready yet.';
            this.snackbarService.error(message);
            return Promise.reject(message);
        }

        const stripe = this.props.stripe;
        const elements = this.props.elements;

        return stripe.confirmPayment({
            elements: elements,
            clientSecret: this.props.clientSecret,
            confirmParams: {
                return_url: this.props.returnUrl
            },
            redirect: 'if_required'
        } as any).then((result: PaymentIntentResult) => {
            if (result.error) {
                throw StripeErrorMapper.mapStripeError(result.error);
            }
        }).catch((err: any) => {
            const message = typeof err === 'string' ? err : 'Unable to confirm payment.';
            EventUtil.fireEvent<string>(EventTypeHolder.paymentFailure, message);
            this.snackbarService.error(message);
            return Promise.reject(message);
        });
    };

    private validateBeforeSubmit = async (): Promise<boolean> => {
        const elements = this.props.elements;
        if (elements && typeof (elements as any).submit === 'function') {
            const result = await (elements as any).submit();
            if (result?.error) {
                const message = result.error?.message
                    || 'Please complete required fields (email and full name).';
                this.snackbarService.error(message, 4000);
                return false;
            }
            return true;
        }

        if (!this.props.paymentElementComplete) {
            this.snackbarService.error('Please complete required fields (email and full name).', 4000);
            return false;
        }

        return true;
    };

    render() {
        return <PrePaymentSubmitButton
            sendPaymentRequest={this.sendPaymentRequest}
            submitButtonDisabled={this.props.submitButtonDisabled}
            beforeSubmit={this.validateBeforeSubmit}
        />

    }
}
